import Alert from "@material-ui/lab/Alert";
import React from "react";
import CommonLinkedMessage from "../../common/LinkedMessage";

const LoginFormAlert: React.FC = () => {
  return (
    <Alert severity="error" data-testid="generalError" style={{ margin: 16 }}>
      <CommonLinkedMessage
        i18nKey="login.error"
        to="https://www.warhammer.com/contact-us"
        testId="generalError"
        target="_blank"
        rel="noopener"
      />
    </Alert>
  );
};

export default LoginFormAlert;
